import React from 'react'
import ReactDOM from 'react-dom/client'
import bugsnag from '@bugsnag/js'
import BugsnagPluginReact, { BugsnagPluginReactResult } from '@bugsnag/plugin-react'
import { Error as ErrorView } from './pages'
import TagManager from 'react-gtm-module'
import Hotjar from '@hotjar/browser'
import { isEdumiamHostname, setFeatureFlagsEnv } from './utils/featureFlags'
import App from './App'

setFeatureFlagsEnv({
  VITE_FEATURE_IPERIA_BI_SALES_FORM: import.meta.env.VITE_FEATURE_IPERIA_BI_SALES_FORM,
  VITE_INSCRIPTION_EDUMIAM_HOSTNAMES: import.meta.env.VITE_INSCRIPTION_EDUMIAM_HOSTNAMES,
})

bugsnag.start({
  appType: 'front',
  apiKey: '5e623f6ca4c6e7dd0f140a342791d0cb',
  plugins: [new BugsnagPluginReact()],
  enabledReleaseStages: ['production'],
})

if (!isEdumiamHostname()) {
  TagManager.initialize({
    gtmId: 'GTM-KXRW9SL',
  })

  const siteId = 5224053
  const hotjarVersion = 6

  Hotjar.init(siteId, hotjarVersion)

  Hotjar.init(siteId, hotjarVersion, {
    debug: true,
  })
}

const plugin = bugsnag.getPlugin('react') as BugsnagPluginReactResult
const ErrorBoundary = plugin.createErrorBoundary(React)

const onError = (event: any) => {
  console.log('event', event)
}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <ErrorBoundary FallbackComponent={ErrorView} onError={onError}>
      <App />
    </ErrorBoundary>
  </React.StrictMode>,
)
